export function areArraysEqual(array1, array2, itemComparer = (a, b) => a === b) {
  return array1.length === array2.length && array1.every((value, index) => itemComparer(value, array2[index]));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/base/utils/areArraysEqual.js
// module id = 1146
// module chunks = 31